module.exports = __webpack_public_path__ + "img/header-brush.8d6f78a1.png";